import {Typography,Grid,ListItem, Container,CardActions,Card,CardContent} from '@material-ui/core';
import useStyles from './styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import React from 'react';

const Education = (props)=>{
    const classes = useStyles();
    const cards = [
        {
            id:1,
            school:'M S Ramaiah Institute of Technology',
            graduation:'BE Computer Science Engineering',
            details:'Studying Computer science from August 2019, will graduate in 2022,',
            score:'9.02'
        },
        {   
            id:2,
            school:'Narayana PU College',
            graduation:'PUC',
            details:'Studied PUC from April 2016 to May 2018, in Sahakara Nagar, Bangalore.',
            score:'88%'
        },
        {
            id:3,
            school:'Seshadripuram Public School',
            graduation:'10th ICSE',
            details:'Studied high school in year 2015-2016, in Yelahanka,Bangalore.',
            score:'93%'
        }
    ];
    const courses = [
        'Data Structures',
        'Design and Analysis of Algorithms',
        'Object Oriented Programming',
        'Computer Networks',
        'Database Management Systems',
        'Operating Systems',
        'Artificial Intelligence',
        'Project Management',
        'Image Processing'
    ];
    const skills = [
        'C','JAVA','Python','JavaScript','MYSQL','MongoDb','Node.js','React.js','Express.js','Flask','HTML','CSS','Git','JDBC','TensorFlow'
    ]
    return (
        <main className={classes.main}>
                    <Container className={classes.container} maxWidth='md'>
                        <Typography variant='h2' align='center' color='textPrimary' gutterBottom>
                            Education
                        </Typography>
                        <Typography variant = 'h5' align='center' color = 'textSecondary'>
                            Here is some details aboutn my past education and some highlights on some of my skills and knowledge.
                        </Typography>
                    </Container>
        <Grid className={classes.grid} container spacing={2}>
            <Grid className={classes.details} sm={12} xs={12} md={6} lg={6} xl={6} item>
                <Grid className={classes.cards} container spacing={2}>
                    {cards.map(card=>(
                        <Grid key={card.id} item xs={12} sm={12} md={12}>
                        <Card className={classes.card}>
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant='h4'>
                                    {card.graduation}
                                </Typography>
                                <Typography gutterBottom variant='h5'>
                                    {card.school}
                                </Typography>
                                <Typography gutterBottom variant='body2'>
                                    {card.details}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Typography gutterBottom variant='subtitle1'>
                                    Score: {card.score}
                                </Typography>
                            </CardActions>
                        </Card>
                    </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid className={classes.grid} sm={12} xs={12} md={6} lg={6} xl={6} item>
                    <Container className={classes.courses} maxWidth='lg'>
                        <Container className={classes.course} maxWidth='md'>
                        <Typography  variant='h3'>Relavant Courses</Typography>
                            {courses.map(course=>(<ListItem key={course} className={classes.list}><ArrowForwardIosIcon/><Typography variant='h6'>{course}</Typography></ListItem>))}
                        </Container>
                        <Container className={classes.skills} maxWidth='md'>
                            <Typography  variant='h3'>Skills</Typography>
                            {skills.map(skill=>(<span key={skill} className={classes.skill}>{skill} </span>))}
                        </Container>
                    </Container>
            </Grid>
        </Grid>
        </main>
    )
}
export default Education;